export default {
      id: "patreon-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "img/iconaf3563da19c86b00e5da1e83cc285294.svg#patreon",
      toString: function () {
        return this.url;
      }
    }